import contentitems from './content/items/reducers'

export default {
  contentitems,
}
